import { GridItem } from '@sainsburys-tech/luna-grid'
import { Cancel } from '@sainsburys-tech/luna-icons'

function ImagePreview({ images, removeImage }: any) {
  if (!images || images.length <= 0) {
    return null
  }

  return Object.entries(images).map(([key, image]: any) => (
    <GridItem key={key} size={{ xs: '1/2' }}>
      <div className="s-image-container">
        <button
          type="button"
          className="s-remove-image-button ln-u-margin-left icon-top-left"
          onClick={() => removeImage(image)}
        >
          <Cancel size="Large" fixed />
        </button>
        <img
          src={image.previewUrl}
          className="s-uploaded-image"
          alt="issueImage"
        />
      </div>
    </GridItem>
  ))
}

export default ImagePreview
